/**
 * The function checks if a given URL has a protocol (http or https).
 * @param [url] - The `url` parameter is a string that represents a URL. The function `hasProtocol`
 * checks whether the URL has a protocol (either "http://" or "https://") at the beginning of the
 * string.
 * @returns The function `hasProtocol` is returning a boolean value indicating whether the input `url`
 * string has a protocol of either `http` or `https`.
 */
export function hasProtocol(url = '') {
  return /^https?:\/\//i.test(url)
}
